import { RecordBase } from '../../providers/request/record-base.model';

export class JgVisualInspReportFile extends RecordBase {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  fileId?: string;
  fileMd5?: string;
  fileSn?: string;
  fileName?: string;
  comment?: string;
}
